module.exports = __webpack_public_path__ + "img/img12.850e69d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/03/img12.png
// module id = 221
// module chunks = 0